// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"525":"7e9c97e7","1373":"7c08792b","2630":"0f519826","4379":"819c7fae","4540":"aa5af5d2","9190":"aa5af5d2","9441":"819c7fae"}[chunkId] + ".chunk.css";
};